import { PricingPlan } from '@/types/pricing-plan';
import { axiosInstance, QueryParams } from './req';
import { Paginated } from '@/types/pagination';

export const loadPlansByTypes = async (type: string): Promise<PricingPlan[]> => {
    return axiosInstance.get(`/api/subscriptions/plans/enum/${type}`).then(({ data }) => data.plans || []);
};
